import {Component, ElementRef, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Globals} from '../../sharedComponents/global-variables/globals';


@Component({
    selector: 'app-forms',
    templateUrl: './forms.component.html',
    styleUrls: ['./forms.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class FormsComponent implements OnInit {

  isActiveLink: boolean;

  constructor(public globals: Globals) {
      this.isActiveLink = false;
  }

  openState(){
    window.open(this.globals.i18n.link.stateucinfo);
  }

  ngOnInit() {

  }



}
